/** @format */

import React, { PureComponent, SyntheticEvent } from 'react';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardBody from '../../components/Card/CardBody';
import { connect } from 'react-redux';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import { provisionigConstants } from '../../modules/provisioning/action';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { history } from '../../core/history';
import MvnoBlockApiRequest from '../../interfaces/platform/MvnoBlockApiRequest';
import I18n from '../../components/Translate/I18n';
import ApiKsaviViewDetail from '../Provisioning/components/ApiKsaviViewDetail';
import { CallBlock } from '../PlkFunctions/GoToCallBlock';
import { ConfigWrapper } from '../../core/ConfigWrapper';
import { operationAction, operationStatus } from '../../modules/block/OperationStatus';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';

interface BlockViewControllerProps {
    dispatch: any;
    mvnoBlockRequest: MvnoBlockRequest;

    reloadViewBlock(): void;

    viewDialog(title: any | string | null, content: any | null): void;

    showMainLoader(show: boolean): void;
}

interface BlockViewControllerState {
    blockId: number | null;
    alert: any | null;
}

class BlockViewController extends PureComponent<BlockViewControllerProps, BlockViewControllerState> {
    private itemLoader: ItemLoaders;

    private config: ConfigWrapper;

    constructor(props: BlockViewControllerProps, context: BlockViewControllerState) {
        super(props, context);

        this.state = {
            blockId: null,
            alert: null,
        };
        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.config = new ConfigWrapper();
    }

    viewApiRequest = (): void => {
        const { mvnoBlockRequest, showMainLoader } = this.props;
        if (!mvnoBlockRequest.mvnoBlockApiRequest) {
            return;
        }
        showMainLoader(true);
        this.itemLoader.getWithCallback(
            FormGeneralHelper.getByUri(mvnoBlockRequest.mvnoBlockApiRequest),
            'mvno_block_api_request_load_item',
            (data: MvnoBlockApiRequest): void => {
                const { viewDialog } = this.props;
                const title = <I18n trans="prov:h.api_operation_type" valueObject={{ type: 'Partner' }} />;
                viewDialog(title, <ApiKsaviViewDetail item={data} onlyApi={true} />);
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchErrorAfterCallback: true, dispatchAfterCallback: false }
        );
    };

    fullBlockReload = (): void => {
        const { mvnoBlockRequest } = this.props;
        this.setState({
            blockId: mvnoBlockRequest.id,
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.callApi({
                            id: mvnoBlockRequest.id,
                            operationType: operationAction.OPERATION_RESTART,
                        });
                    }}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content="prov:list.confirm_reload_block_operation"
                />
            ),
        });
    };

    restartFromCurrentPlace = (): void => {
        const { mvnoBlockRequest } = this.props;
        this.setState({
            blockId: mvnoBlockRequest.id,
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.callApi({
                            id: mvnoBlockRequest.id,
                            operationType: operationAction.OPERATION_RESTART_FROM_CURRENT_POSITION,
                        });
                    }}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content="prov:f.confirm_restart_from_current_place"
                />
            ),
        });
    };

    breakBlock = (): void => {
        const { mvnoBlockRequest } = this.props;
        this.setState({
            blockId: mvnoBlockRequest.id,
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.callApi({
                            id: mvnoBlockRequest.id,
                            operationType: 2,
                        });
                    }}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content="prov:list.confirm_break_block_operation"
                />
            ),
        });
    };

    manageBlockAfterBreak = (operationTypeRequest: number): void => {
        const { mvnoBlockRequest } = this.props;
        let content = 'prov:list.confirm_finish_block_as_ok';
        if (operationTypeRequest === operationAction.OPERATION_ERROR_STOP) {
            content = 'prov:list.confirm_finish_block_as_error';
        }
        this.setState({
            blockId: mvnoBlockRequest.id,
            alert: (
                <AlertInfo
                    onConfirm={(): void => {
                        this.callApi({
                            id: mvnoBlockRequest.id,
                            operationType: operationTypeRequest,
                        });
                    }}
                    onCancel={this.cancelActivate}
                    confirmBtnText={'simcard:f.save_change'}
                    cancelBtnText={'general:common.cancel'}
                    content={content}
                />
            ),
        });
    };

    cancelActivate = (fn: any): void => {
        this.setState({ alert: null, blockId: null }, (): void => {
            if (typeof fn === 'function') {
                fn();
            }
        });
    };

    callApi = (params: any): void => {
        const { mvnoBlockRequest, reloadViewBlock } = this.props;
        this.cancelActivate(() => {
            this.itemLoader.putWithCallback(
                FormGeneralHelper.getUrl('/operation_on_blocks/' + mvnoBlockRequest.id),
                provisionigConstants.OPERTATION_ON_BLOCK,
                params,
                (data: any) => {
                    reloadViewBlock();
                },
                { propagateDataToCallback: true }
            );
        });
    };

    callViewBlock = (block: CallBlock, event?: SyntheticEvent): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(
            event,
            FormGeneralHelper.getRouteUrl('/block-request-detail/' + this.config.getApiMvnoBlockRequestById(block.blockId))
        );
    };

    render(): React.ReactNode {
        const { mvnoBlockRequest } = this.props;
        const { alert } = this.state;

        const apiRequestButtonEnable = mvnoBlockRequest.mvnoBlockApiRequestId !== null;
        let restartBlockButtonEnable =
            (mvnoBlockRequest.requestEnd && mvnoBlockRequest.errorState) ||
            mvnoBlockRequest.operationStatus === operationStatus.OPERATION_STATUS_BREAK;
        if (mvnoBlockRequest.blockFullyRestarted) {
            restartBlockButtonEnable = false;
        }

        let breakBlock = mvnoBlockRequest.requestEnd;
        if (mvnoBlockRequest.requestEnd && mvnoBlockRequest.errorState) {
            breakBlock = false;
        }

        let cancelColor = 'warning';
        let restartColorEnable = 'grey';
        let viewApiColorEnable = 'grey';

        if (!apiRequestButtonEnable) {
            viewApiColorEnable = 'lightGreen';
        }

        if (restartBlockButtonEnable) {
            restartColorEnable = 'tumblr';
        }

        if (breakBlock) {
            cancelColor = 'grey';
        }

        return (
            <React.Fragment>
                <Card>
                    <CardBody>
                        {mvnoBlockRequest.mvnoBlockApiRequestId &&
                            <CustomTextButtom
                                callback={this.viewApiRequest}
                                color={viewApiColorEnable}
                                label="prov:f.view_api_request"
                                disabled={!apiRequestButtonEnable}
                                size="sm"
                            />
                        }
                        {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_BLOCK) && (
                            <React.Fragment>
                                {mvnoBlockRequest.requestEnd && mvnoBlockRequest.errorState && !mvnoBlockRequest.cancel &&
                                    <>
                                        <CustomTextButtom
                                            callback={this.fullBlockReload}
                                            color={restartColorEnable}
                                            label="prov:f.full_block_reload"
                                            disabled={!restartBlockButtonEnable}
                                            size="sm"
                                        />
                                        <CustomTextButtom
                                            callback={this.restartFromCurrentPlace}
                                            color={restartColorEnable}
                                            label="prov:f.restart_from_current_place"
                                            disabled={!restartBlockButtonEnable}
                                            size="sm"
                                        />
                                    </>
                                }
                                {!mvnoBlockRequest.requestEnd && mvnoBlockRequest.operationStatus === null && (
                                    <CustomTextButtom
                                        callback={this.breakBlock}
                                        color={cancelColor}
                                        label="prov:list.call_break"
                                        disabled={breakBlock}
                                        size="sm"
                                    />
                                )}
                                {!mvnoBlockRequest.requestEnd && mvnoBlockRequest.operationStatus === operationStatus.OPERATION_STATUS_BREAK && (
                                    <React.Fragment>
                                        <CustomTextButtom
                                            callback={(): void => this.manageBlockAfterBreak(operationAction.OPERATION_ERROR_STOP)}
                                            color="tumblr"
                                            label="prov:list.finish_block_as_error"
                                            disabled={breakBlock}
                                            size="sm"
                                        />
                                        <CustomTextButtom
                                            callback={(): void => this.manageBlockAfterBreak(operationAction.OPERATION_OK_STOP)}
                                            color="tumblr"
                                            label="prov:list.finish_block_as_ok"
                                            disabled={breakBlock}
                                            size="sm"
                                        />
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                        {mvnoBlockRequest.blockFullyRestarted && mvnoBlockRequest.mvnoBlockRequestPrevId && (
                            <CustomTextButtom
                                callback={this.callViewBlock}
                                callbackParam={{ blockId: mvnoBlockRequest.mvnoBlockRequestPrevId }}
                                label="prov:vb.view_prev_restarted_block"
                                size="sm"
                            />
                        )}
                        {mvnoBlockRequest.calledFromBlockId && (
                            <CustomTextButtom
                                callback={this.callViewBlock}
                                callbackParam={{ blockId: mvnoBlockRequest.calledFromBlockId }}
                                label="prov:vb.view_parent_block"
                                size="sm"
                            />
                        )}
                    </CardBody>
                </Card>
                {alert}
            </React.Fragment>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(BlockViewController);
